import { Field, Formik, Form } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, FormGroup, Label, Row } from "reactstrap";
import { __t } from "../../../i18n/translator";
import SimpleReactValidator from "simple-react-validator";

export default function AddEditLink({ initialData, addEditLinkManagementRequest,dispatchData ,onModalDismiss}) {
    const validator = useRef(new SimpleReactValidator());
    const handleSubmit = async (values) => {
        if (validator.current.allValid()) {
          addEditLinkManagementRequest({ values, dispatchData , onModalDismiss});
        } else {
          validator.current.showMessages();
        }
      };
    return (
        <Formik initialValues={initialData} onSubmit={handleSubmit}>
            {({ isSubmitting, values, setFieldValue }) => (
                <>
                    <Form className="form-horizontal form-login">
                        <div className="category-head">
                            <FormGroup className=" mb-3">
                                <Field
                                    type="text"
                                    id="title"
                                    name="title"
                                    className="form-control"
                                    placeholder="Title"
                                />
                                <Label className="form-label" htmlFor="title">
                                    Title<span className="text-danger required">*</span>
                                </Label>
                                {validator.current.message(
                                    __t("validations.link.title"),
                                    values.title,
                                    "required",
                                    {
                                        messages: {
                                            required: __t("validations.link.title"),
                                        },
                                    }
                                )}
                            </FormGroup>

                            <FormGroup className="mb-3">
                                <Field
                                    type="url"
                                    id="url"
                                    name="url"
                                    className="form-control"
                                    placeholder="URL"
                                />
                                <Label className="form-label" htmlFor="url">
                                    URL<span className="text-danger required">*</span>
                                </Label>
                                {validator.current.message(
                                    __t("validations.link.url"),
                                    values.url,
                                    "required|url",
                                    {
                                        messages: {
                                            required: __t("validations.link.url"),
                                        },
                                    }
                                )}
                            </FormGroup>
                            <Row>
                                <Col sm={6}>
                                    <FormGroup className="mb-3">
                                        <Field
                                            as="select"
                                            id="visibleTo"
                                            name="visibleTo"
                                            className="form-control"
                                        >
                                            <option value="members_only">Member Portal</option>
                                            <option value="admins_only">Admin Portal</option>
                                        </Field>
                                        <Label className="form-label" htmlFor="visibleTo">
                                            Visible To
                                        </Label>
                                    </FormGroup>
                                </Col>

                                <Col sm={6}>

                            {/* Open New Tab */}
                            <FormGroup className="mb-3">
                                <div className="form-check">
                                    <Field
                                        type="checkbox"
                                        name="openNewTab"
                                        id="openNewTab"
                                        className="form-check-input"
                                        checked={values.openNewTab}
                                        onChange={() =>
                                            setFieldValue("openNewTab", !values.openNewTab)
                                        }
                                    />
                                    <Label className="form-check-label" htmlFor="openNewTab">
                                        Open in New Tab
                                    </Label>
                                </div>
                            </FormGroup>
                                </Col>
                            </Row>

                        </div>
                        <div className="btn-box d-flex gap-2">
                            <Button
                                color="primary"
                                className=""
                                title="user data"
                                type="submit"
                                disabled={isSubmitting}
                            >
                                {initialData?.id ? "Update" : "Submit"}
                            </Button>
                            <Button
                                // color="primary"
                                className=""
                                title="user data"
                                type="button"
                                onClick={()=>onModalDismiss()}
                                // disabled={isSubmitting}
                            >
                               Close
                            </Button>
                        </div>
                    </Form>
                </>
            )}
        </Formik>
    );
}
